import { render, staticRenderFns } from "./PositionDialogs.vue?vue&type=template&id=010c0bfa&scoped=true"
import script from "./PositionDialogs.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionDialogs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PositionDialogs.vue?vue&type=style&index=0&id=010c0bfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010c0bfa",
  null
  
)

export default component.exports